var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { ChipFilters, FilterInfrationsEnum } from "../../components/Infracoes/ChipFilters";
import { Loading } from "../../components/Loading";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { CardInfracao } from "../../components/Veiculos/CardInfracao";
import { InfoVeiculo } from "../../components/Veiculos/InfoVeiculo";
import { obterInfracoes } from "../../services/veiculos.service";
export var Infracoes = function () {
    var placa = useParams().placa;
    var _a = useState(), infracoes = _a[0], setInfracoes = _a[1];
    var _b = useState(FilterInfrationsEnum.TODAS), filter = _b[0], setFilter = _b[1];
    var _c = useState(false), consultaVazia = _c[0], setConsultaVazia = _c[1];
    var _d = useState(false), erro = _d[0], setErro = _d[1];
    var _e = useState(true), loading = _e[0], setLoading = _e[1];
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, 4, 5]);
                        if (!placa) return [3 /*break*/, 2];
                        payload = {
                            placa: placa,
                        };
                        return [4 /*yield*/, obterInfracoes(payload)];
                    case 1:
                        response = _b.sent();
                        if (response[0].descricaoinfracao) {
                            sortRecords(response);
                        }
                        else {
                            setConsultaVazia(true);
                        }
                        _b.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        if (error_1.response &&
                            ((_a = error_1.response.data) === null || _a === void 0 ? void 0 : _a.MensagemRetorno) ===
                                "Veículo Não Possui Infrações Registradas na Base do Detran.") {
                            setConsultaVazia(true);
                        }
                        else {
                            setErro(true);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var sortRecords = function (record) {
            if (record) {
                var sortedInfractions = record.sort(function (a, b) {
                    var dateA = new Date(a.dataAuto.split('/').reverse().join('-'));
                    var dateB = new Date(b.dataAuto.split('/').reverse().join('-'));
                    return dateB.getTime() - dateA.getTime();
                });
                setInfracoes(sortedInfractions);
            }
        };
        fetchData();
    }, [placa]);
    useEffect(function () {
        if (!placa)
            return;
        var fetchRecord = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, allRecords, filterOpenRecords, filterCanceledRecords, filterPaidRecords, filterOverdueRecords;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setConsultaVazia(false);
                        return [4 /*yield*/, obterInfracoes({ placa: placa }).then(function (record) {
                                var sortedInfractions = record.sort(function (a, b) {
                                    var dateA = new Date(a.dataAuto.split('/').reverse().join('-'));
                                    var dateB = new Date(b.dataAuto.split('/').reverse().join('-'));
                                    return dateB.getTime() - dateA.getTime();
                                });
                                return sortedInfractions;
                            }).catch(function (e) { return console.log(e); })];
                    case 1:
                        response = _a.sent();
                        if (response) {
                            allRecords = function () { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    setInfracoes(response);
                                    return [2 /*return*/];
                                });
                            }); };
                            filterOpenRecords = function () {
                                var filterRecords = response.filter(function (item) { return item.descricaoStatus === 'Em aberto'; });
                                if (filterRecords.length > 0) {
                                    setInfracoes(filterRecords);
                                }
                                else {
                                    setInfracoes(undefined);
                                    setConsultaVazia(true);
                                }
                            };
                            filterCanceledRecords = function () {
                                var filterRecords = response.filter(function (item) { return item.descricaoStatus === 'Cancelado'; });
                                if (filterRecords.length > 0) {
                                    setInfracoes(filterRecords);
                                }
                                else {
                                    setInfracoes(undefined);
                                    setConsultaVazia(true);
                                }
                            };
                            filterPaidRecords = function () {
                                var filterRecords = response.filter(function (item) { return item.descricaoStatus === 'Pago'; });
                                if (filterRecords.length > 0) {
                                    setInfracoes(filterRecords);
                                }
                                else {
                                    setInfracoes(undefined);
                                    setConsultaVazia(true);
                                }
                            };
                            filterOverdueRecords = function () {
                                var overdueRecords = response.filter(function (item) { return (new Date(item.dataVencPenalidade.split('/').reverse().join('-'))) < new Date(); });
                                var overdueAndOpenRecords = overdueRecords.filter(function (item) { return item.descricaoStatus === 'Em aberto'; });
                                if (overdueAndOpenRecords.length > 0) {
                                    setInfracoes(overdueAndOpenRecords);
                                }
                                else {
                                    setInfracoes(undefined);
                                    setConsultaVazia(true);
                                }
                            };
                            switch (filter) {
                                case FilterInfrationsEnum.TODAS:
                                    allRecords();
                                    break;
                                case FilterInfrationsEnum.EM_ABERTO:
                                    filterOpenRecords();
                                    break;
                                case FilterInfrationsEnum.CANCELADAS:
                                    filterCanceledRecords();
                                    break;
                                case FilterInfrationsEnum.PAGAS:
                                    filterPaidRecords();
                                    break;
                                case FilterInfrationsEnum.EM_ATRASO:
                                    filterOverdueRecords();
                                    break;
                                default:
                                    break;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        fetchRecord();
    }, [filter]);
    if (loading) {
        return _jsx(Loading, {});
    }
    return (_jsxs(Stack, __assign({ style: { width: '100%' } }, { children: [_jsx(FixedMenu, { title: "Infra\u00E7\u00F5es do Ve\u00EDculo", goBackTo: "/veiculos/infracoes" }), _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsx(InfoVeiculo, {}), _jsx(ChipFilters, { newFilter: function (value) { return setFilter(value); } }), !consultaVazia ? (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "h5", fontSize: "1.375rem", fontWeight: "500", mb: "1rem" }, { children: "Infra\u00E7\u00F5es do Ve\u00EDculo" })), _jsx(Divider, { sx: { mb: "1rem" } }), infracoes === null || infracoes === void 0 ? void 0 : infracoes.map(function (infracao, index) { return (_jsx(CardInfracao, { infracao: infracao }, index)); })] })) : (_jsx(Box, __assign({ mt: "10rem" }, { children: _jsx(NaoEncontrado, { subtitulo: "O sistema n\u00E3o localizou nenhuma infraca\u00E7\u00E3o para o ve\u00EDculo selecionado." }) })))] }) })), erro && (_jsx(SnackbarFeedback, { isOpen: erro, message: "Erro ao buscar infra\u00E7\u00F5es", type: "error" })), loading && _jsx(Loading, {})] })));
};
